import React from 'react'
import robot from '../../Assets/robot.svg'
import guru from '../../Assets/guru.svg'
import arrow from '../../Assets/arrow.svg'
import arrowM from '../../Assets/arrowMobile.svg'
import speakToNeo from '../../Assets/speakToNeo.svg'
import watchDemo from '../../Assets/watchDemo.svg'
import joinedPeople from '../../Assets/joinedPeopleDoodle.svg'
import twitter from '../../Assets/twitter.png'
import instagram from '../../Assets/instagram.png'
import youtube from '../../Assets/youtube.png'
import linkedIn from '../../Assets/linkedin.png'
import toyota from '../../Assets/toyotaLogo.png'
import mcD from '../../Assets/mcDLogo.png'

import './Intro.css'

const OldCustomers = () => {

    // yahan pr motion lgana h aur ek naya component bna k us m sare customers k data/logo ko bhejna h aur wahan pr hi render krna h
    return (

        <div className='oldCustomersContainer'>
            <h5>Trusted by 100 companies</h5>
            <div className="customersLogo">
                <img src={toyota} alt="" />
                <img src={mcD} alt="" />
                <img src={toyota} alt="" />
                <img src={mcD} alt="" />
                <img src={toyota} alt="" />
                <img src={mcD} alt="" />
                <img src={toyota} alt="" />
            </div>
        </div>
    )
}

const Intro = () => {
    return (
        <>
            <div className="introContainer">
                <div className="introArea">
                    <div className="introText">
                        <span className='neo'>Neo</span>
                        <p>Your Advanced Health Guru <img src={guru} alt="guru" /> Ask Anything Know Everything!</p>
                    </div>
                    <div className="introActions">
                        <img src={arrow} alt="arrow" className="arrow" />
                        <img src={arrowM} alt="arrow" className="arrowM" />
                        <div className="introText2">
                            <p className="lightText">
                                Experience the convenience, speed, and reliability of medical information right at your fingertips
                            </p>

                            <div className="introActionContainer">
                                <a href="" className='introActions'>
                                    <img src={speakToNeo} alt="" className='introActionImg' />
                                </a>
                                <a href="" className='introActions'>
                                    <img src={watchDemo} alt="" className='introActionImg' />
                                </a>
                            </div>

                            <div className="socialMedia">
                                <div className="peopleContainer">
                                    <p>2000+ People Joined</p>
                                    <img src={joinedPeople} alt="" />
                                </div>
                                <div className="socialMediaContainer">
                                    <p>Our Social Media</p>
                                    <div id="socialMediaLinks">
                                        <img src={instagram} alt="" />
                                        <img src={youtube} alt="" />
                                        <img src={twitter} alt="" />
                                        <img src={linkedIn} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <img src={robot} alt="" className='robot' />
            </div>

            <OldCustomers />
        </>
    )
}

export default Intro;